import React from 'react';
import '../assets/styles/App.css';
import "@fontsource/montserrat";
import {useAuth0} from "@auth0/auth0-react";
import {useAuth} from "../components/Authentication/AuthProvider";
import IndexNavbar from "../components/Navbars/IndexNavbar.js";


function Login() {
    const {
        error, isAuthenticated, loginWithRedirect, getAccessTokenSilently, isLoading, logout
    } = useAuth0();
    const {fetchUser, token} = useAuth();

    React.useEffect(() => {
        if (isAuthenticated)
            getAccessTokenSilently().then((token) => {
                fetchUser(token);
            }
        ).catch((error) => {
                console.error('Could not get access token', error);
                setTimeout(()=> logout(),5000);
            });
        else if (!error && !isLoading) {
            loginWithRedirect({
                appState: {
                    returnTo: '/login',
                },
            })
        }
    }, [isAuthenticated, isLoading]);


    document.title = "Sign In";

    return(<>
        <section>
            <IndexNavbar/>
        </section>


        <section className="relative pb-20">
            <div className="container relative mx-auto text-center pt-12 px-4">
                {isLoading && <div className="bg-blue-v-light rounded-lg text-blue ">You will be redirected shortly...</div>}
                {error && <div className="bg-red-200 rounded-lg text-blue ">Failed to authenticate - ${error.message}</div>}
            </div>
        </section>
    </>);
}

export default Login;